// extracted by mini-css-extract-plugin
export var activeDot = "_2e-c";
export var buttonContainer = "_2e-9";
export var channelButton = "_2e-a";
export var clickable = "_2e-d";
export var content = "_2e-0";
export var contentFull = "_2e-2";
export var contentThird = "_2e-1";
export var contentWrapper = "_2e-7";
export var description = "_2e-5";
export var heightShort = "_2e-f";
export var image = "_2e-3";
export var imageContainer = "_2e-4";
export var selectButton = "_2e-e";
export var spinnerContainer = "_2e-b";
export var titleContent = "_2e-8";
export var titleWrapper = "_2e-6";